import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

console.log(process.env.VUE_APP_BASE_LOCALE);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: ['de', 'en', 'es', 'fr', 'it', 'pt', 'cn', 'da', 'fi', 'hu', 'ja', 'ko', 'nl', 'no', 'sv'].map(l => {
    let nl = 'en';
    if (l === 'de') {
      nl = 'de';
    }
    return [
      {
        path: '/' + l + '/impressum',
        component: () => import('../views/' + nl + '/Imprint.vue'),
      },
      {
        path: '/' + l + '/imprint',
        component: () => import('../views/' + nl + '/Imprint.vue'),
      },
      {
        path: '/' + l + '/agb',
        component: () => import('../views/' + nl + '/TermCondition.vue'),
      },
      {
        path: '/' + l + '/tos',
        component: () => import('../views/' + nl + '/TermCondition.vue'),
      },
      {
        path: '/' + l + '/datenschutzerklaerung',
        component: () => import('../views/' + nl + '/PrivacyPolicy.vue'),
      },
      {
        path: '/' + l + '/privacy',
        component: () => import('../views/' + nl + '/PrivacyPolicy.vue'),
      }
    ]
  }) .reduce(function (accumulator, ps) {
    return accumulator.concat(ps);
  }, []).concat([
    {
      path: '/:lang',
      component: {
        render: (h) => h('router-view'),
      },
      children: [
        {
          path: 'versand',
          name: 'versand',
          component: () => import('../views/ShippingPayment.vue'),
        },
        {
          path: 'shipping',
          name: 'shipping',
          component: () => import('../views/ShippingPayment.vue'),
        },
        {
          path: '',
          name: 'home',
          component: () => import('../views/Home.vue'),
        },
        {
          path: "*",
          redirect: '/'
        }
      ],
    },
    {
      path: '',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/',
      component: () => import('../views/Home.vue'),
    },
  ]),
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
});

export default router;
